import { FC, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { NoteItem } from '../../../types/note-setting';
import { fetchNoteItem } from '../../../network/noteCrud';
import NoteSettingForm from './components/NoteSettingForm';

const NoteSettingDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noteItem, setNoteItem] = useState<NoteItem>();

  const reloadData = async () => {
    if (id) {
      setIsLoading(true);
      try {
        const res = await fetchNoteItem(id, dispatch);
        setNoteItem(res);
      } catch (err) {
        history.push(NOT_FOUND_ERROR_PAGE_PATH);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    reloadData();
  }, [id]);

  return <>{isLoading || !noteItem ? <LayoutSplashScreen /> : <NoteSettingForm noteItem={noteItem} />}</>;
};

export default NoteSettingDetailPage;
